export default __webpack_public_path__ + "static/media/bg-chatbot.3e875671.webp";